import React from 'react';

import { EVENT_ADDON_ITEM_TYPE } from '../../../constants/event-items';
import { SEARCH_SUBSCRIPTION_PLAN } from '../../../apps/temp/views/onboarding/PhotoSearchCheckout/helpers';
import { ACCOUNT_PRO_ROLES } from '../../../constants/account-roles';

export const PURCHASE_TYPE = {
  EVENTS: 'EVENTS',
  PHOTO_MANAGER_SUBSCRIPTION: 'PHOTO_MANAGER_SUBSCRIPTION',
  SEARCH_SUBSCRIPTION: 'SEARCH_SUBSCRIPTION',
};

export const ACCOUNT_PRO_ROLES_MAPPINGS = {
  [ACCOUNT_PRO_ROLES.PHOTOGRAPHER]: 'Pro',
  [ACCOUNT_PRO_ROLES.EVENT_ORGANIZER]: 'Events',
  [ACCOUNT_PRO_ROLES.CAMP_ADMIN]: 'Camps',
  [ACCOUNT_PRO_ROLES.CHURCH_ADMIN]: 'Church',
  [ACCOUNT_PRO_ROLES.RESORT_ADMIN]: 'Resorts',
  [ACCOUNT_PRO_ROLES.GREEK_ADMIN]: 'Greek',
  [ACCOUNT_PRO_ROLES.SCHOOL_ADMIN]: 'Schools',
  [ACCOUNT_PRO_ROLES.SPORTS_ADMIN]: 'Sports',
};

export const THANK_YOU_HEADERS = ({
  purchaseType,
  proRole = ACCOUNT_PRO_ROLES.PHOTOGRAPHER,
}) => {
  if (purchaseType === PURCHASE_TYPE.EVENTS) {
    return (
      <p className="text-center">
        Congrats on Waldo-fying your event!
        <br />
        Let&apos;s share some memories!
      </p>
    );
  }

  if (purchaseType === PURCHASE_TYPE.PHOTO_MANAGER_SUBSCRIPTION) {
    return (
      <p className="text-center">
        Congrats on joining Waldo{ACCOUNT_PRO_ROLES_MAPPINGS[proRole] ?? 'Pro'}!
        <br />
        Let&apos;s get to business!
      </p>
    );
  }

  // purchaseType === PURCHASE_TYPE.SEARCH_SUBSCRIPTION
  return (
    <p className="text-center">
      Welcome to Waldo Plus!
      <br />
      Let&apos;s share some memories!
    </p>
  );
};

export const EVENT_TYPE_LABELS = {
  [EVENT_ADDON_ITEM_TYPE.WALDOFIED]: 'Live Event Album',
  [EVENT_ADDON_ITEM_TYPE.WALDOFIED_PHOTO_FINDER]: 'Photo Finder Event',
  [EVENT_ADDON_ITEM_TYPE.WALDOFIED_PHOTO_FINDER_PLUS]:
    'Photo Finder Plus Event',
  [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: 'Memories Smart Slideshow',
  [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: 'Video Guestbook',
};

export const SEARCH_SUBSCRIPTION_LABELS = {
  [SEARCH_SUBSCRIPTION_PLAN.SHUTTERBUG_PLUS]: 'Waldo Plus',
  [SEARCH_SUBSCRIPTION_PLAN.SHUTTERBUG_PREMIUM]: 'Waldo Premium',
};
